/**
 * LinkifiedText: renderiza texto plano detectando URLs (http/https) y
 * convirtiéndolas en hipervínculos clickeables. Preserva los saltos de línea.
 *
 * Uso: <LinkifiedText>{post.contenido}</LinkifiedText>
 *
 * - Sólo hace match a URLs que comienzan con http:// o https://
 * - Se abre en nueva pestaña con rel="noopener noreferrer"
 * - Se pueden pasar className extra para heredar estilos de contenedor
 */
import React from 'react';

// Regex de URL: match http(s)://, luego cualquier char que no sea espacio, ), ], ", ', <, >
const URL_REGEX = /(https?:\/\/[^\s()<>[\]"']+)/g;

// Limpia caracteres finales que probablemente sean puntuación (no parte de la URL)
const TRAILING_PUNCT = /[.,;:!?)\]}>]+$/;

const cleanUrl = (raw) => {
  const match = raw.match(TRAILING_PUNCT);
  if (!match) return { url: raw, trailing: '' };
  return { url: raw.slice(0, -match[0].length), trailing: match[0] };
};

export default function LinkifiedText({ children, className = '', linkClassName = '' }) {
  const text = typeof children === 'string' ? children : '';
  if (!text) return null;

  const parts = text.split(URL_REGEX);
  return (
    <span className={`whitespace-pre-wrap break-words ${className}`}>
      {parts.map((part, i) => {
        if (i % 2 === 1) {
          // parte capturada por el grupo → es una URL
          const { url, trailing } = cleanUrl(part);
          return (
            <React.Fragment key={i}>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className={`text-purple-700 hover:text-purple-900 underline underline-offset-2 break-all ${linkClassName}`}
                data-testid="linkified-url"
              >
                {url}
              </a>
              {trailing}
            </React.Fragment>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
}
